import { storeHelpers } from 'src/utils/store';
import type { AnyAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';

const initialState: Record<AnyAction['type'], boolean> = {};

export const apiFulfilledReducer = createReducer(initialState, (builder) =>
  builder
    .addMatcher(storeHelpers.getIsActionFulfilled, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'fulfilled')]: true,
    }))
    .addMatcher(storeHelpers.getIsActionPending, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'pending')]: false,
    }))
    .addMatcher(storeHelpers.getIsActionRejected, (state, action) => ({
      ...state,
      [storeHelpers.getBaseAction(action.type, 'rejected')]: false,
    })),
);
